<template>
  <gmap-map
    v-if="activity"
    ref="mapRef"
    :center="center"
    :map-type-id="mapTypeId"
    :zoom="zoom"
    :options="options"
    class="mb-4"
  >
    <gmap-marker
      v-for="(item, index) in markers"
      :key="index"
      :position="item.position"
    />
  </gmap-map>
</template>

<script>
export default {
  name: 'ActivityMap',
  props: {
    activity: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    bounds: {},
    mapTypeId: 'roadmap',
    zoom: 11,
    options: {
      mapTypeControl: false,
      streetViewControl: false,
    },
  }),
  computed: {
    center() {
      const placeholderLatLon = { lat: 38.582526, lng: -101.075826 }
      if (!this.activity) return placeholderLatLon

      // TODO: Reconcile lng vs lon on the backend
      const { lat, lon } = this.activity.geo_location
      return {
        lat,
        lng: lon,
      }
    },
    markers() {
      return [{ position: this.center }]
    },
  },
}
</script>

<style lang="scss">
.vue-map-container {
  height: 300px;
  width: 100%;
}
</style>
